module.exports = {
  name: 'phone', base: '_field', prototype: {
    element_selector: '.phone input, input.phone',
    valid: /^(?=[^()]*\(([^()]*\)[^()]*)?$|[^()]*$)(?=[\s(]*\+[^+]*$|[^+]*$)([-+.\s()]*\d){10,18}$/
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/phone.js
 ** module id = 25
 ** module chunks = 0
 **/